import React from "react";
import { TYPE_PC } from "../../../common/defines";
import { customer_voice } from "../../../common/customer_voice";

export const okunai = ({ type }) => {
  return (
    <div className="tab_panel">
      <div className="characteristic">
        <div className="title">屋内型トランクルームのおススメポイント</div>
        <div className="text">
          ・首都圏最大数の拠点数を展開
          <br />
          ・セコムまたはALSOKのセキュリティで安心安全
          <br />
          ・24時間使用可能
          <br />
          ・人気な中規模サイズのお部屋が豊富
          <br />
          ・首都圏中心に約17,000室
          <br />
        </div>
      </div>
      {type === TYPE_PC ? customer_voice(type, true) : ""}
    </div>
  );
}



// WEBPACK FOOTER //
// ./pages/new/lineup/okunai.jsx